import { render, staticRenderFns } from "./folders-counterparties-options-detail.vue?vue&type=template&id=fe220f50&scoped=true"
import script from "./folders-counterparties-options-detail.vue?vue&type=script&lang=js"
export * from "./folders-counterparties-options-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe220f50",
  null
  
)

export default component.exports